import { useOkapiKy } from '@folio/stripes/core';
import { useQuery } from 'react-query';
import { fetchRecord } from '../api/recordService';
/**
 * Hook for fetching a single authority record detail.
 * Skips the request when id is undefined (no record selected).
 */
var useRecordDetail = function (id) {
    var ky = useOkapiKy();
    var _a = useQuery(['record', id], function () { return fetchRecord(ky, id); }, {
        enabled: !!id,
        // Neretryovat 404 — CZNA-696.
        //
        // 404 je DEFINITIVNÍ odpověď: záznam neexistuje a příště existovat nebude.
        // react-query ale retryuje třikrát s backoffem 1+2+4 s, takže se na jistou
        // odpověď čeká ~7 s a `isLoading` po celou tu dobu drží. `<Loading />` je
        // spinner bez přístupného textu, takže detailní panel je celou tu dobu
        // z pohledu čtenáře (i snímku accessibility tree) PRÁZDNÝ — vypadá to jako
        // rozbitá obrazovka, ne jako čekání.
        //
        // Naměřeno 25. 8. v traceu: `GET records/{id}` → 404, 404, 404, a asserce na
        // „Záznam nebyl nalezen" vypršela na 15s stropu, protože hláška přijde teprve
        // po vyčerpání retry. Test tím pádem procházel nebo padal podle toho, kolik
        // z těch 15 s spolkla zbytek obrazovky — v šesti dnešních bězích 1× prošel,
        // 2× byl flaky a 3× spadl, aniž se cokoli v kódu změnilo.
        //
        // Tohle není ústupek testu: retryovat odpověď, která se nemůže změnit, je
        // vada sama pro sebe — uživatel kouká 7 s na spinner místo na hlášku.
        retry: function (failureCount, err) {
            var _a;
            var status = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.status;
            if (status === 404)
                return false;
            return failureCount < 3;
        },
    }), data = _a.data, isLoading = _a.isLoading, isError = _a.isError, error = _a.error, refetch = _a.refetch;
    return {
        record: data,
        isLoading: isLoading,
        isError: isError,
        error: error,
        refetch: refetch,
    };
};
export default useRecordDetail;
